module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/jonathan/Skypager/~/babel-runtime/core-js/promise.js
// module id = ../../node_modules/babel-runtime/core-js/promise.js
// module chunks = 0